// extracted by mini-css-extract-plugin
module.exports = {"input":"deleteControl_input_AGZXf","inputContainer":"deleteControl_inputContainer_3saiB"};